module.exports = __webpack_public_path__ + "img/default_bg.1ec6df70.jpg";